import { render, staticRenderFns } from "./LongArrow.vue?vue&type=template&id=67e9e549"
import script from "./LongArrow.vue?vue&type=script&lang=js"
export * from "./LongArrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports